import React, { Component } from "react";
import close from "../../../include/images/icon-close.svg";
import icon from "../../../include/images/send-icon.svg";
import {
  chatReceived,
  chatReceivedAll,
  getChats,
  loadChatForDoctor,
} from "../../../store/chats";
import { io } from "socket.io-client";
import { getPatient, loadPatientProfile } from "../../../store/patient";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment";
import AvtarImage from "../../common/avtarImage";
import { collection, setDoc, doc, query, where, orderBy, getDocs, updateDoc, getDoc, limit, } from "firebase/firestore";
import {db} from "../../../firebase";
import { sendMessage } from "../../../chatUtils/chatUtiles";
import loaderIcon from '../../../include/images/loading-icon2.svg'
class Messages extends Component {
  state = {
    ready: false,
    msgData: "",
    appointmentDateScrolled: false,
    initialBottomScrollDone: false,
    loading: true,
  };
  myRef = React.createRef();
  scrollToMyRef = (appointmentDate = "") => {
    if (this.myRef.current) {
      let element = document.getElementById(appointmentDate);

      if (appointmentDate && element && this.props.initial) {
        this.myRef.current.scrollTo(0, element.offsetTop -(document.getElementsByClassName('sidebar-head')[0].offsetHeight + 90))
      } else {
        const chatBox = this.myRef.current;
        const isUserNearBottom =
          chatBox.scrollTop + chatBox.clientHeight >= chatBox.scrollHeight - 100;

        if (isUserNearBottom) {
          chatBox.scrollTo({
            top: chatBox.scrollHeight,
            behavior: "smooth",
          });
        }
      }
    }
  };
  scrollToBottom = () => {
    if (this.myRef.current) {
      this.myRef.current.scrollTo({
        top: this.myRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };


  loadMessages = async () => {
    if (!this.props.doctor_id || !this.props.patient_id) return;
    const q = query(
      collection(db, "messages"),
      where("sender", "in", [this.props.doctor_id, this.props.patient_id]),
      where("receiver", "in", [this.props.doctor_id, this.props.patient_id]),
      orderBy("created_on", "desc"),
      limit(20)
    );
    const snapshot = await getDocs(q);
    const msgs = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        ...data,
        created_on: data.created_on?.toDate?.().toISOString() || data.created_on,
        time: data.time?.toDate?.().toISOString() || data.time,
      };
    });
    const displayMsgs = msgs.reverse()
    // console.log("msgs----------787---------------> ", displayMsgs)
    this.props.chatReceivedAll(displayMsgs);
    const chatId = `${this.props.doctor_id}_${this.props.patient_id}`;
    const chatDocRef = doc(db, "chatsSummary", chatId);
    const chatDocSnap = await getDoc(chatDocRef);
    // console.log("chatDocSnap ------> ",chatDocSnap)
    if(chatDocSnap.exists() && this.props.isShow === true){
      const data = chatDocSnap.data();
      if (data.readByDoctor === false) {
      console.log("i am updating---------->")
      await updateDoc(doc(db, "chatsSummary", chatId), {
        readByDoctor: true,
      }, { merge: true });
    }
  }
    // this.scrollToMyRef();
  };

  handleSend = async (msg) => {
    if (msg) {
      await sendMessage({
        msg: this.state.msgData,
        doctorId: this.props.doctor_id,
        patientId: this.props.patient_id,
        sender: this.props.doctor_id,
      });
      // this.props.setInitial()
      this.setState({ msgData: "" }, () => {
        this.scrollToBottom();
      });
      this.loadMessages();
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.pollInterval);
  };
  
  componentDidUpdate = (prevProps, prevState) => {
    // console.log("------componentDidUpdate------")
    const { appointmentDate, chats, patient_id, doctor_id } = this.props;
    const chatJustOpened = this.props.isShow && !prevProps.isShow;
    const patientChanged = patient_id && patient_id !== prevProps.patient_id;
    const doctorChanged = doctor_id && doctor_id !== prevProps.doctor_id;
    if (chatJustOpened || patientChanged || doctorChanged) {
      this.setState({ loading: true }, () => {
        this.loadMessages().then(() => {
          this.setState({ loading: false });
        });
      });
    }
    if (patientChanged || doctorChanged) {
      console.log("Patient or Doctor Changed - Resetting scroll flags");
      this.setState({
        appointmentDateScrolled: false,
        initialBottomScrollDone: false,
      });
    }  
    if (this.props.appointmentDate !== prevProps.appointmentDate) {
      this.setState({
        appointmentDateScrolled: false,
        initialBottomScrollDone: false,
      });
    }

    if (prevState.loading && !this.state.loading && chats.length > 0) {
      if (appointmentDate && !this.state.appointmentDateScrolled) {
        this.scrollToMyRef(appointmentDate);
        this.setState({ appointmentDateScrolled: true });
      } else if (!appointmentDate && !this.state.initialBottomScrollDone) {
        this.scrollToBottom();
        this.setState({ initialBottomScrollDone: true });
      }
    }

    // if (
    //   this.props.appointmentDate &&
    //   !this.state.appointmentDateScrolled &&
    //   this.props.chats.length > 0
    // ) {
    //   this.scrollToMyRef(this.props.appointmentDate);
    //   this.setState({ appointmentDateScrolled: true });
    // }
    // if (
    //   !this.props.appointmentDate &&
    //   !this.state.initialBottomScrollDone &&
    //   this.props.chats.length > 0
    //   //  &&
    //   // prevProps.chats.length === 0
    // ) {
    //   console.log("Scrolling to bottom...");
    //   this.scrollToBottom();
    //   this.setState({ initialBottomScrollDone: true });
    // }
    // if (prevState.loading && !this.state.loading) {
    //   this.scrollToBottom();
    // }
  };

  componentDidMount = () => {
    this.loadMessages().then(() => {
      this.setState({ loading: false }); 
    });
    this.pollInterval = setInterval(() => {
      this.loadMessages();
    }, 5000);
  };

  render() {
  const days = moment().diff(
    moment(this.props.lastAppointment.appointment_time),
    "days"
  );
  // this.scrollToMyRef();
  return (
    <>
      <div
        className={
          this.props.isShow === true
            ? "sidebar-box notesopen"
            : "sidebar-box notesclose"
        }
        id="calculator"
      >
        <div class="sidebar-head d-flex align-items-center">
          <h5>
            Chats{" "}
            <small>
              (Active for 3 days post appointment. Not for Emergency
              purposes.)
            </small>
          </h5>
          <div
            class="close-img ml-auto"
            onClick={(e) => {
              e.preventDefault();
              this.props.toggle(this.props.patient_id, this.props.doctor_id);
            }}
          >
            <img src={close} alt="" />
          </div>
        </div>
        <div class="sidebar-body height-auto">
          <div class="chats-box">
            <div class="chats-head d-flex align-items-center">
              <div class="d-flex align-items-center">
                <div class="doc-thumbnails">
                  {this.props.image ? (
                    <img
                      style={{ borderRadius: "50%" }}
                      src={process.env.REACT_APP_S3URL + this.props.image}
                      alt=""
                    />
                  ) : (
                    <AvtarImage />
                  )}
                </div>
                <div class="doc-text-box">
                  <h4>{this.props.doc_name}</h4>
                </div>
              </div>
            </div>
            <div class="chat-area">
              <div class="chat" ref={this.myRef}>
                {this.state.loading ? (
                  <div>
                    <b className='d-flex justify-content-center align-items-center pt-4 text-center'>
                      <img
                        src={loaderIcon}
                        alt='loader'
                        className='loader-img fa-spin'
                        style={{ height: '15px' }}
                      />
                    </b>
                  </div>
                  ) : (
                  this.props.chats.map((es, i) => {
                  const createdOn = es.created_on?.toDate?.() || es.created_on;
                  const time = es.time?.toDate?.() || es.time;
                  return (
                    <>
                      {(i === 0 ||
                        moment(
                          this.props.chats[i - 1]?.created_on?.toDate?.() ||
                            this.props.chats[i - 1]?.created_on
                        ).format("DD/MM/YYYY") !==
                          moment(createdOn).format("DD/MM/YYYY")) && (
                        <div
                          class="chat-seprator"
                          id={moment(createdOn).format("DD/MM/YYYY")}
                        >
                          <span>{moment(createdOn).format("DD/MM/YYYY")}</span>
                          <div className="alert_box">
                            <div className="alert_box_content">
                            This chat is between you and patient only. YesMindy has no role in the messages exchanged here. Please refrain from advising anything critical over messages and keep it for simple queries or thought journaling. Reach out to YesMindy clinical team for any support needed. 
                            </div>
                          </div>  
                        </div>
                      )}
                      {this.props.doctor_id === es.sender ? (
                        <div class="chat-message-box send-message">
                          <div>
                            <div class="chat-message">
                              {es.msg || es.message}
                            </div>
                          </div>
                          <div class="time">
                            {moment(createdOn).format("hh:mm:ss A")}
                          </div>
                        </div>
                      ) : (
                        <div class="chat-message-box received-message d-flex flex-column align-items-end">
                          <div class="d-flex flex-column">
                            <div class="chat-message">
                              {es.msg || es.message}
                            </div>
                          </div>
                          <div class="time">
                            {moment(time || createdOn).format("hh:mm:ss A")}
                          </div>
                        </div>
                      )}
                    </>
                  );
                }))}
              </div>
              {/* {this.props.lastAppointment.appointment_time && days < 3 && ( */}
                <div class="send" style={{ padding: "17px 0 17px" }}>
                  <input
                    onChange={(e) =>
                      this.setState({ msgData: e.target.value })
                    }
                    className="input-message"
                    name="msgData"
                    value={this.state.msgData}
                    placeholder="Write your message…"
                    type="text"
                    id="message"
                    onKeyDown={(e) => {
                      if (e.key === "Enter")
                        this.handleSend(this.state.msgData);
                    }}
                  />{" "}
                  <button
                    className="input-send"
                    onClick={(e) => {
                      if (this.state.msgData)
                        this.handleSend(this.state.msgData);
                    }}
                  >
                    <i>
                      <img src={icon} alt="" />
                    </i>
                  </button>
                </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      <div
        className={this.props.isShow === true ? "overlay4 show" : "overlay4"}
      ></div>
    </>
  );
}
}
const mapStateToProps = (state) => ({
  patientProfile: getPatient(state).profile,
  patientHistory: getPatient(state).history,
  psychiatrist: getPatient(state).psychiatrist,
  psychologist: getPatient(state).psychologist,
  loading: getPatient(state).loading,
  chats: getChats(state).chatData,
  lastAppointment: getChats(state).lastAppointment,
});
const mapDispatchToProps = (dispatch) => ({
  loadPatientProfile: () => dispatch(loadPatientProfile()),
  chatReceived: (data) => dispatch(chatReceived(data)),
  chatReceivedAll: (data) => dispatch(chatReceivedAll(data)),
  loadChatForDoctor: (id) => dispatch(loadChatForDoctor(id)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Messages)
);
